/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getTemplates(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`, { params });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates/sync`);
  }

  createTemplate(inboxId, templateData) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      whatsapp_template: templateData,
    });
  }

  updateTemplate(inboxId, templateId, templateData) {
    return axios.patch(
      `${this.url}/${inboxId}/whatsapp_templates/${templateId}`,
      { whatsapp_template: templateData }
    );
  }

  deleteTemplate(inboxId, templateId) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_templates/${templateId}`
    );
  }
}

export default new WhatsappTemplatesAPI();
